// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrap{background-image:linear-gradient(#cfd2d7,#e0e3e6);position:relative;color:#444;height:100vh;font-size:.16rem;line-height:.3rem}.wrap img{width:5rem;top:50%;margin-top:-2rem}.wrap .tex,.wrap img{position:absolute;left:50%;margin-left:-2.5rem}.wrap .tex{top:60%}.wrap span{cursor:pointer;color:#0c73ff;margin:0 .1rem}.center{text-align:center}", ""]);
// Exports
module.exports = exports;
